export const selectUserState = (state) => state.user;
export const selectUser = (state) => state.user.user;
export const selectIsLoggedIn = (state) => state.user.isLoggedIn;

export const selectSelectedTenant = (state) =>
  state.user.tenants[state.user.selectedTenantId];

export const selectSelectedTenantId = (state) => state.user.selectedTenantId;
export const selectTenants = (state) =>
  Object.values(state.user.tenants);
